var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 262,
    viewBox: "0 0 321 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_1808_3521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.38 192.111C208.383 226.295 88.1026 224.67 44.7082 138.549C1.31385 52.4277 59.5559 18.093 119.313 28.3096C165.412 36.1948 182.904 39.5889 202.734 18.6555C226.043 -5.95013 283.325 -10.5068 302.07 55.7874C320.815 122.082 302.07 163.502 259.38 192.111Z",
    fill: "url(#paint0_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.886 202.584V112.69H106.291V197.386C110.414 199.303 114.613 201.036 118.886 202.584Z",
    fill: "url(#paint1_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.835 190.21C97.1871 192.834 101.678 195.225 106.288 197.374V112.677L92.8381 115.462L92.835 190.21Z",
    fill: "url(#paint2_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 197.529L42.9854 135.042C43.5439 136.201 44.1151 137.367 44.7084 138.548C48.5248 146.141 53.1037 153.333 58.3758 160.016L217.469 208.899C229.555 206.271 240.654 202.408 250.14 197.529Z",
    fill: "url(#paint3_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.874 149.634L104.251 109.47L42.9854 135.042L250.14 197.529C253.323 195.901 256.408 194.091 259.38 192.11C276.878 180.377 290.35 166.498 298.874 149.634Z",
    fill: "url(#paint4_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.937 178.955V138.62L272.605 146.989V191L228.937 178.955Z",
    fill: "url(#paint5_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.605 146.99V191.001L303.172 171.702V130.976L272.605 146.99Z",
    fill: "url(#paint6_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.172 130.976L272.605 146.99L228.937 138.62L264.883 124.431L303.172 130.976Z",
    fill: "url(#paint7_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.07 141.327V155.625L252.982 157.716V143.227L243.07 141.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.982 143.227L285.632 127.978L275.527 126.25L243.07 141.327L252.982 143.227Z",
    fill: "url(#paint8_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.437 146.032L117.739 122.573L88.5898 135.187L187.727 161.489L215.437 146.032Z",
    fill: "url(#paint9_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5898 135.187L187.727 161.49V164.787L88.5898 137.422V135.187Z",
    fill: "url(#paint10_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.726 161.491V164.788L215.436 149.246V146.033L187.726 161.491Z",
    fill: "url(#paint11_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.411 88.4614H180.003V115.73C180.006 119.431 177.901 122.817 174.562 124.481L166.373 128.544V131.356L187.791 135.657C187.791 135.657 202.73 128.884 202.73 124.406L203.825 94.0401L183.411 88.4614Z",
    fill: "url(#paint12_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.822 94.0293H201.415V121.31C201.418 125.011 199.313 128.398 195.974 130.061L187.788 134.124V136.937L197.255 131.852C201.265 129.777 203.779 125.666 203.778 121.185L203.822 94.0293Z",
    fill: "url(#paint13_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.791 134.12L166.376 128.551V131.351L187.791 136.92V134.12Z",
    fill: "url(#paint14_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.449 117.726L141.245 100.084C138.642 99.6617 136.556 97.0864 136.556 94.3268V33.2393C136.556 30.4765 138.642 28.2388 141.245 28.2388H250.449C254.551 28.2388 257.896 31.0953 257.896 34.6175V112.56C257.896 116.073 254.539 118.389 250.449 117.726Z",
    fill: "url(#paint15_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.164 117.726L138.96 100.084C136.359 99.6617 134.273 97.0864 134.273 94.3268V33.2393C134.273 30.4765 136.359 28.2388 138.96 28.2388H248.164C252.266 28.2388 255.614 31.0953 255.614 34.6175V112.56C255.614 116.073 252.253 118.389 248.164 117.726Z",
    fill: "url(#paint16_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.636 57.9912L245.999 59.4444",
    stroke: "white",
    strokeWidth: 9.9242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.636 72.3118L245.999 74.9901",
    stroke: "white",
    strokeWidth: 9.9242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.636 85.8977L234.626 88.5791",
    stroke: "white",
    strokeWidth: 9.9242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.426 38.651C201.426 35.9014 199.175 33.6724 196.398 33.6724H143.985C141.801 33.6724 140.05 35.5476 140.05 37.8697V89.1249C140.05 91.4439 141.801 93.6066 143.985 93.9598L195.597 102.307C197.052 102.542 198.538 102.132 199.661 101.187C200.784 100.241 201.432 98.8546 201.432 97.3945L201.426 38.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4188 130.013L63.3175 144.333C63.3175 144.333 78.0957 146.13 91.4255 146.255C104.755 146.38 111.253 145.727 112.484 148.13C112.484 148.13 115.324 148.586 115.166 151.205C115.166 151.205 117.006 151.562 116.933 153.44C117.946 154.492 118.137 156.079 117.403 157.337C116.157 159.584 113.743 163.9 113.083 163.119C112.424 162.338 113.591 158.456 113.591 158.456C113.591 158.456 106.762 159.631 102.49 158.397C98.2166 157.162 73.5578 165.063 60.7803 164.879C48.0027 164.694 39.0752 160.859 39.0752 149.593C39.0752 138.326 41.1864 123.74 41.1864 123.74L64.4188 130.013Z",
    fill: "url(#paint17_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1012 135.92C64.1012 135.92 71.6024 99.9098 65.6791 92.0527C59.7558 84.1956 45.7002 81.561 42.0427 103.494C38.3852 125.428 38.1706 133.313 40.3733 135.223C43.8478 138.226 58.869 141.677 64.1012 135.92Z",
    fill: "url(#paint18_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6611 167.213C62.6611 167.213 105.005 162.525 121.168 161.487C137.332 160.45 147.749 166.447 149.327 184.487L82.4254 195.572L62.6611 167.213Z",
    fill: "url(#paint19_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4103 178.911C51.4103 178.911 47.0649 203.729 69.1802 212.896C90.8632 221.884 124.891 225.259 150.913 202.526L153.618 211.117C153.618 211.117 170.47 213.736 186.699 212.752C186.699 212.752 184.333 190.44 177.586 178.911C175.263 174.942 167.636 166.447 147.553 169.966C142.333 170.882 120.445 177.095 120.445 177.095C117.059 177.13 76.7224 167.007 73.4499 166.622C53.4489 164.278 51.4103 178.911 51.4103 178.911Z",
    fill: "url(#paint20_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7852 77.6309C77.8937 72.6665 78.79 67.2795 78.4013 61.9075H102.413C102.413 61.9075 100.28 72.4804 107.213 79.778C107.213 79.778 85.407 86.6662 75.7852 77.6309Z",
    fill: "url(#paint21_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9423 160.601C52.9276 127.438 48.0836 112.839 45.7641 104.304C43.4447 95.7689 44.0253 90.4528 56.9575 83.8083C69.8896 77.1639 68.8388 77.6421 68.8388 77.6421L112.823 81.7988C112.823 81.7988 133.894 88.8026 136.917 96.6815C138.287 100.263 126.917 119.871 126.917 143.183C126.917 167.911 131.625 183.528 129.041 186.313C122.287 193.582 55.3575 193.144 49.2796 182.603C47.1747 178.946 48.5348 176.318 49.9423 160.601Z",
    fill: "url(#paint22_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5176 78.8938C66.5176 78.8938 73.618 74.4966 74.8676 74.0528C76.1173 73.6091 81.6682 77.5156 92.991 76.6936C103.563 75.9248 103.683 74.1654 105.077 75.0217C107.643 76.5999 112.822 81.7971 112.822 81.7971C112.822 81.7971 84.3316 91.9039 66.5176 78.8938Z",
    fill: "url(#paint23_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.308 35.7734C113.968 38.8625 114.39 41.9969 114.571 45.1493C114.634 46.2776 119.336 47.8746 116.556 50.4436C115.609 51.3093 114.593 51.2374 114.466 52.5313C113.693 60.4696 114.451 72.0864 103.964 70.1519C103.964 70.1519 85.661 65.4451 82.2844 61.9667C73.8239 53.2376 76.5473 38.3299 81.1704 31.6511C87.646 22.3407 109.812 22.8439 113.308 35.7734Z",
    fill: "url(#paint24_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3072 60.3013C98.7182 59.1657 98.3 57.8987 97.2911 57.2228C95.2967 55.8696 92.4502 53.0943 93.2896 48.6345C94.5519 41.9463 101.826 41.4087 104.284 46.853L108.134 46.9593C108.134 46.9593 107.307 40.6211 111.564 37.8552C115.822 35.0893 121.767 31.2921 120.331 28.3699C118.895 25.4477 116.333 25.3227 116.333 25.3227C116.333 25.3227 111.826 19.8221 104.994 19.519C98.1621 19.2158 95.9215 18.4658 89.1051 18.8033C82.2888 19.1408 77.4795 23.5819 77.6783 29.0356C77.6783 29.0356 68.6939 28.7543 67.5799 41.365C66.466 53.9756 77.3627 67.1832 77.3627 67.1832C77.3627 67.1832 84.1286 71.8368 93.6652 69.4897C94.5386 69.2803 95.2488 68.6531 95.5586 67.8177L98.3072 60.3013Z",
    fill: "url(#paint25_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7207 48.2969C96.7207 48.2969 100.927 48.2969 101.71 52.6565",
    stroke: "#382824",
    strokeWidth: 3.96968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.98,
    cy: 56.9693,
    rx: 2.66974,
    ry: 2.64391,
    fill: "url(#paint26_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.248 131.463L148.126 145.527C148.126 145.527 162.842 143.268 175.701 139.789C188.561 136.311 194.636 133.936 196.478 135.914C196.478 135.914 199.319 135.601 199.906 138.148C199.906 138.148 201.771 137.995 202.222 139.82C203.485 140.559 204.105 142.035 203.743 143.443C203.162 145.943 202.023 150.734 201.177 150.175C200.332 149.615 200.385 145.549 200.385 145.549C200.385 145.549 194.134 148.521 189.684 148.487C185.235 148.453 163.678 162.698 151.339 165.989C139 169.28 129.337 167.98 126.257 157.132C123.177 146.284 121.18 131.685 121.18 131.685L145.248 131.463Z",
    fill: "url(#paint27_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.075 137.408C148.075 137.408 143.881 100.564 136.033 94.5914C128.185 88.6189 113.902 89.9034 116.423 111.974C118.945 134.045 120.898 141.712 123.546 142.956C127.715 144.918 145.57 142.206 148.075 137.408Z",
    fill: "url(#paint28_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.814 139.569L149.339 153.954",
    stroke: "white",
    strokeWidth: 3.96968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.027 217.257C130.027 217.257 86.4054 141.312 77.9481 134.467C66.6064 125.291 13.5713 112.953 11.0877 126.029C9.38045 135.033 34.8535 202.19 43.7715 209.328C60.1214 222.417 130.27 230.433 130.027 217.257Z",
    fill: "url(#paint29_linear_1808_3521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.012 210.884C163.489 201.118 165.301 191.223 165.301 191.223L137.792 205.79C131.702 209.017 124.124 206.874 120.672 200.949C109.713 182.163 87.2438 144.193 78.8338 134.436C64.2733 117.506 13.5544 112.962 11.0804 126.026C11.0197 126.385 10.9933 126.749 11.0015 127.113C11.6326 126.535 12.491 126.52 13.5544 126.532C22.8544 126.623 54.1592 128.095 66.5138 141.737C73.6142 149.569 99.6206 199.071 112.338 223.933C128.423 223.411 144.088 217.629 152.012 210.884Z",
    fill: "url(#paint30_linear_1808_3521)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1808_3521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.717 47.9865L157.973 45.7128C154.699 45.4119 152.044 47.8338 152.044 51.1221V75.9707C152.044 79.2591 154.699 82.1688 157.973 82.4697L182.717 84.7434C185.992 85.0443 188.647 82.6224 188.647 79.334V54.4854C188.647 51.1971 185.992 48.2874 182.717 47.9865Z",
    fill: "#03DA18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.526 47.05L157.973 45.7128C154.699 45.4119 152.044 47.8338 152.044 51.1221V75.9707C152.044 79.2591 154.699 82.1688 157.973 82.4697L165.608 83.1712C159.599 75.3822 161.861 62.2165 166.4 57.4164C170.783 52.7815 172.121 48.872 172.526 47.05Z",
    fill: "#03DA18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.734 74.1456C167.983 74.0765 167.257 73.721 166.709 73.1493L158.996 65.1081C157.814 63.8764 157.763 61.9993 158.882 60.9155C160 59.8318 161.864 59.9515 163.046 61.1835L168.565 66.9363L177.478 57.7986C178.566 56.6834 180.428 56.7553 181.638 57.9585C182.848 59.1619 182.947 61.0415 181.859 62.1567L170.925 73.3662C170.394 73.9105 169.647 74.1947 168.853 74.154C168.813 74.152 168.774 74.1492 168.734 74.1456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.046 61.1835C161.864 59.9515 160 59.8318 158.882 60.9155C157.763 61.9993 157.814 63.8764 158.996 65.1081L162.123 68.3687C162.379 66.027 162.936 63.7968 163.708 61.8736L163.046 61.1835Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_1808_3521",
    x: 0,
    y: 0,
    width: 320.327,
    height: 262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1808_3521"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1808_3521",
    result: "effect2_dropShadow_1808_3521"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1808_3521",
    result: "effect3_dropShadow_1808_3521"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1808_3521",
    result: "effect4_dropShadow_1808_3521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1808_3521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1808_3521",
    x1: 392.187,
    y1: 279.26,
    x2: 392.187,
    y2: -56.5959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1808_3521",
    x1: 107.384,
    y1: 157.953,
    x2: 132.25,
    y2: 167.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1808_3521",
    x1: 5.38982,
    y1: 468.058,
    x2: 104.83,
    y2: 468.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1808_3521",
    x1: 255.993,
    y1: 253.405,
    x2: 260.108,
    y2: 155.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1808_3521",
    x1: 170.93,
    y1: 109.47,
    x2: 170.93,
    y2: 197.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FFDF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1808_3521",
    x1: 209.573,
    y1: 264.625,
    x2: 376.003,
    y2: 264.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1808_3521",
    x1: 252.223,
    y1: 277.382,
    x2: 370.764,
    y2: 277.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1808_3521",
    x1: 187.893,
    y1: 154.672,
    x2: 312.693,
    y2: 154.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1808_3521",
    x1: 282.608,
    y1: 152.051,
    x2: 287.64,
    y2: 123.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1808_3521",
    x1: 152.014,
    y1: 122.573,
    x2: 152.014,
    y2: 161.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1808_3521",
    x1: 4.55192,
    y1: 138.556,
    x2: 12.9241,
    y2: 208.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1808_3521",
    x1: 195.041,
    y1: 184.151,
    x2: 215.497,
    y2: 151.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48567D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1808_3521",
    x1: 174.56,
    y1: 63.7001,
    x2: 152.444,
    y2: 119.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1808_3521",
    x1: 172.626,
    y1: 125.202,
    x2: 201.219,
    y2: 130.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1808_3521",
    x1: 217.182,
    y1: 134.237,
    x2: 207.336,
    y2: 110.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1808_3521",
    x1: 312.333,
    y1: 47.4553,
    x2: 243.036,
    y2: 47.4553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A4A6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1808_3521",
    x1: 129.606,
    y1: 134.452,
    x2: 295.938,
    y2: 134.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1808_3521",
    x1: 150.223,
    y1: 112.382,
    x2: 27.9607,
    y2: 112.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1808_3521",
    x1: 53.455,
    y1: 86.3496,
    x2: 53.455,
    y2: 139.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1808_3521",
    x1: 13.0278,
    y1: 169.602,
    x2: 17.3439,
    y2: 241.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1808_3521",
    x1: 118.882,
    y1: 166.368,
    x2: 118.882,
    y2: 219.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1808_3521",
    x1: 66.3401,
    y1: 84.4314,
    x2: 104.37,
    y2: 84.4314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1808_3521",
    x1: 90.8684,
    y1: 77.6345,
    x2: 90.8684,
    y2: 191.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1808_3521",
    x1: 89.6696,
    y1: 74.0176,
    x2: 89.6696,
    y2: 85.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1808_3521",
    x1: 116.9,
    y1: 72.3521,
    x2: 116.9,
    y2: 28.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1808_3521",
    x1: 117.119,
    y1: -4.33866,
    x2: 16.5077,
    y2: -4.33866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1808_3521",
    x1: 97.7108,
    y1: 33.6336,
    x2: 97.7108,
    y2: 57.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1808_3521",
    x1: 227.624,
    y1: 102.215,
    x2: 89.4679,
    y2: 172.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1808_3521",
    x1: 132.102,
    y1: 91.5303,
    x2: 132.102,
    y2: 143.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1808_3521",
    x1: 72.8915,
    y1: 241.311,
    x2: 112.936,
    y2: 170.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1808_3521",
    x1: 155.906,
    y1: 103.658,
    x2: -41.7023,
    y2: 103.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1808_3521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.7569,
    height: 36.7569,
    fill: "white",
    transform: "matrix(0.995805 0.0915016 0 1 152.044 45.168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSuccess);
export default __webpack_public_path__ + "static/media/uploadSuccess.569190482d57aad8226259864408cd30.svg";
export { ForwardRef as ReactComponent };